<template>
	<el-dialog :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false" :showClose="false" custom-class="successDialog" width="450px">
		<div class="tipsContent">
			<i class="el-icon-circle-check succIcon"></i>
			<p class="title">提交成功</p>
			<p class="text">您好！你已经成功提交了检测服务相关信息。</p>
			<p class="text">请注意查收订单检测状态。</p>
			<el-button type="primary" round @click="goOrderHandle()">查看我的订单</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	data() {
		return {
			dialogVisible: false,
		}
	},
	methods: {
		init(orderId, orderType) {
			this.orderId = orderId
			this.orderType = orderType
			this.dialogVisible = true
		},
		goOrderHandle() {
			if (this.$route.name == 'orderDetails') {
				this.$emit('setOrderInit')
			} else {
				this.$router.push({ name: 'orderDetails', query: { orderId: this.orderId, st: 2, type: this.orderType } })
			}

			this.dialogVisible = false
		},
	},
}
</script>

<style lang="scss" scoped></style>
